import React from 'react';
import { Section } from './ui/Section';
import { Countdown } from './ui/Countdown';
export function Pricing({
  id
}: {
  id?: string;
}) {
  return <Section id={id} data-id="element-145">
      <div className="text-center mb-10" data-id="element-146">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-accent mb-6" data-id="element-147">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <Countdown data-id="element-148" />
        <p className="text-neutral-400 mt-6 text-lg" data-id="element-149">
          ⚠️ Después sube el precio. No vuelve.
        </p>

        <div className="max-w-md mx-auto mt-8 bg-brand-card border border-neutral-800 rounded-full p-1" data-id="element-150">
          <div className="flex items-center justify-between px-4 py-2 text-sm font-medium" data-id="element-151">
            <span className="text-red-500 flex items-center gap-2" data-id="element-152">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-153"></span>{' '}
              Cupos al precio de lanzamiento
            </span>
            <span className="text-brand-accent" data-id="element-154">72% tomados</span>
          </div>
          <div className="w-full bg-neutral-900 rounded-full h-2 mt-1 mx-2 w-[calc(100%-1rem)] overflow-hidden" data-id="element-155">
            <div className="bg-gradient-to-r from-red-500 to-brand-accent h-2 rounded-full" style={{
            width: '72%'
          }} data-id="element-156"></div>
          </div>
        </div>
      </div>

      <h3 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-157">
        ELEGÍ TU MEGAPACK
      </h3>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-158">
        {/* Basic Kit */}
        <div className="bg-brand-card border border-neutral-800 rounded-3xl p-8 flex flex-col" data-id="element-159">
          <div className="text-xl font-bold mb-2" data-id="element-160">
            📘 MEGAPACK™: TU NEGOCIO BAJO CONTROL
          </div>
          <div className="text-neutral-400 text-sm mb-6 pb-6 border-b border-neutral-800" data-id="element-161">
            6 Tomos + 3 Bonos
            <br data-id="element-162" />
            <span className="text-neutral-500 mt-2 block" data-id="element-163">
              Ideal para: Ordenar tu negocio y empezar a crecer hoy
            </span>
          </div>

          <div className="mb-8 flex-grow" data-id="element-164">
            <div className="flex items-end gap-3 mb-2" data-id="element-165">
              <span className="text-3xl text-neutral-500 line-through font-medium" data-id="element-166">
                49€
              </span>
              <span className="text-5xl font-black text-white" data-id="element-167">17,99€</span>
            </div>
          </div>

          <a href="https://pagos.digipromarket.com/cart/56404832223558:1" target="_blank" rel="noopener noreferrer" className="w-full bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.98] text-center block" data-id="element-168">
            → QUIERO MI MEGAPACK
          </a>
        </div>

        {/* Pro Kit */}
        <div className="bg-neutral-900 border-2 border-brand-accent rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(79,70,229,0.15)] transform md:-translate-y-4" data-id="element-169">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-white font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-170">
            MÁS ELEGIDO ⭐
          </div>

          <div className="text-xl font-bold mb-2 text-brand-accent" data-id="element-171">
            🏆 MEGAPACK™ + TOOLKIT ACELERADOR PRO
          </div>
          <div className="text-neutral-300 text-sm mb-6 pb-6 border-b border-neutral-800" data-id="element-172">
            6 Tomos + 3 Bonos + Sistema de Implementación Técnica
            <br data-id="element-173" />
            <span className="text-brand-accent/80 mt-2 block" data-id="element-174">
              Ideal para: Implementar el sistema completo en la mitad de tiempo
            </span>
          </div>

          <div className="mb-8 flex-grow" data-id="element-175">
            <div className="flex items-end gap-3 mb-2" data-id="element-176">
              <span className="text-3xl text-neutral-500 line-through font-medium" data-id="element-177">
                79€
              </span>
              <span className="text-5xl font-black text-white" data-id="element-178">25,99€</span>
            </div>
          </div>

          <a href="https://pagos.digipromarket.com/cart/56404834189638:1" target="_blank" rel="noopener noreferrer" className="w-full bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(79,70,229,0.4)] text-center block" data-id="element-179">
            → QUIERO EL MEGAPACK + TOOLKIT
          </a>
        </div>
      </div>
    </Section>;
}